const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');
const Modal = require('app/ui/Modal');

const SellerForm = require('app/seller/Form');

class CreateModal {

    defaultOptions() {
        return {
            'id': window.uniqid(),
            'title': window.translate('app.seller.create.title'),
            'onClose': function(event){},
            'onShown': function(event){},
            'onSuccess': function(data){},
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.initialize();
    }

    initialize() {
        var self = this;

        this.build();
    }

    build(){

        this.$content = $('<div/>')
        .addClass('seller-create-modal');

        this.modal = new Modal({
            'id': this.settings.id,
            'title': this.settings.title,
            'showFooter': false,
            'content' : this.$content,
            'modalSize': "full",

            'onShown':this.settings.onShown,
            'onClose':this.settings.onClose,
        })

        this.buildContent();

        this.modal.show();
    }

    buildContent(){

        this.infosForm = new SellerForm({
            'success': this.settings.onSuccess
        });

        this.$content.html('')
        .append(this.infosForm.getForm());
    }
}

module.exports = CreateModal;

